import { Schema } from 'effect';
import { z } from 'zod';

const normalizedCoordinate = Schema.Number.check(Schema.isBetween({ minimum: 0, maximum: 1 }));

/** Effect-native 0–1 bbox codec for wire and persistence boundaries. */
export const BboxCodec = Schema.Struct({
  x: normalizedCoordinate,
  y: normalizedCoordinate,
  w: normalizedCoordinate,
  h: normalizedCoordinate,
});

/** Effect-native legacy web bbox codec. */
export const BboxLegacyCodec = Schema.Struct({
  ymin: Schema.Finite,
  xmin: Schema.Finite,
  ymax: Schema.Finite,
  xmax: Schema.Finite,
  label: Schema.optional(Schema.String),
});

/** 0-1 normalized bounding box (canonical format used by API) */
export const bboxSchema = z.object({
  x: z.number().min(0).max(1),
  y: z.number().min(0).max(1),
  w: z.number().min(0).max(1),
  h: z.number().min(0).max(1),
});

/** Legacy ymin/xmin format (web app) */
export const bboxLegacySchema = z.object({
  ymin: z.number(),
  xmin: z.number(),
  ymax: z.number(),
  xmax: z.number(),
  label: z.string().optional(),
});

export type Bbox = z.infer<typeof bboxSchema>;
export type BboxLegacy = z.infer<typeof bboxLegacySchema>;
